import { MODEL_TITLE_PRESENTATIONS } from "./model-title-presentations";

const MODEL_TITLES = new Map(MODEL_TITLE_PRESENTATIONS.map(([id, sourceName, title]) =>
  [id, { sourceName, title }]
));

/** Match both immutable identity and reviewed source spelling; all other names stay literal. */
export function resolveModelTitle(recordId: string, sourceName: string): string {
  const approved = MODEL_TITLES.get(recordId);
  return approved?.sourceName === sourceName ? approved.title : sourceName;
}
